import { render, staticRenderFns } from "./Rive.vue?vue&type=template&id=742596d2&scoped=true&"
import script from "./Rive.vue?vue&type=script&lang=js&"
export * from "./Rive.vue?vue&type=script&lang=js&"
import style0 from "./Rive.vue?vue&type=style&index=0&id=742596d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742596d2",
  null
  
)

export default component.exports